module.exports = __webpack_public_path__ + "public/SiteIcons/printIcon.svg?ce38801c";